module.exports = __webpack_public_path__ + "assets/img/swaggerAPI.9245ddf9.jpg";